module.exports = __webpack_public_path__ + "static/img/animals5.b970618d.png";